import firebase from 'firebase/compat/app';

import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

export const firebaseApp = firebase.initializeApp(spat.config.firebase);

export default firebase;